import { cloneDeep, concat, filter, find, findIndex, last, isNil } from 'lodash';
import { SET_ANALYSIS_GROUP_PARTICIPATIONS, SET_ANALYSIS_PARTICIPATIONS } from './consts';
import { PROJECTS_TAG } from '../../../projects/data/actions';
import { updateLayer } from './layersDispatchers';

const GROUP_PARTICIPATIONS_TAG = 'GroupParticipations';

const setProjectAnalysisParticipations = participations => {
  return {
    type: SET_ANALYSIS_PARTICIPATIONS,
    participations
  };
};

const setProjectAnalysisGroupParticipations = groupParticipations => {
  return {
    type: SET_ANALYSIS_GROUP_PARTICIPATIONS,
    groupParticipations
  };
};

export const fetchProjectAnalysisParticipations = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, 'getProjectParticipations', {
      projectId,
      $limit: 10000
    });
    console.log(getState());
    dispatch(setProjectAnalysisParticipations(results.data));
  };
};

export const toggleAllActiveLayerParticipations = allParticipations => {
  return async (dispatch, getState, { apiClient }) => {
    const { participations } = getState().analysis.single;
    if (getState().analysis.single.activeLayerId !== null) {
      const activeLayer = cloneDeep(
        find(getState().analysis.single.layers, { id: getState().analysis.single.activeLayerId })
      );
      if (!allParticipations) {
        activeLayer.layer_participation_associations = [];
      } else {
        const participantsToAdd = filter(participations, element => {
          return (
            find(activeLayer.layer_participation_associations, {
              participation_id: element.participation_id
            }) === undefined
          );
        }).map(participation => {
          return {
            layer_id: activeLayer.id,
            participation_id: participation.id
          };
        });
        activeLayer.layer_participation_associations = concat(
          activeLayer.layer_participation_associations,
          participantsToAdd
        );
      }

      dispatch(updateLayer(activeLayer));
    }
  };
};

export const updateActiveLayerParticipations = (participationId, add) => {
  return async (dispatch, getState, { apiClient }) => {
    if (getState().analysis.single.activeLayerId !== null) {
      const activeLayer = cloneDeep(
        find(getState().analysis.single.layers, { id: getState().analysis.single.activeLayerId })
      );

      // Add Association
      if (add) {
        activeLayer.layer_participation_associations.push({
          participation_id: participationId,
          layer_id: activeLayer.id
        });
      } else {
        const associationIndex = findIndex(activeLayer.layer_participation_associations, {
          participation_id: participationId
        });
        activeLayer.layer_participation_associations.splice(associationIndex, 1);
      }

      dispatch(updateLayer(activeLayer));
    }
  };
};

/**
 * Group Participations
 */

export const updateGroupParticipations = groupParticipations => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(
      GROUP_PARTICIPATIONS_TAG,
      'updateGroupParticipations',
      { id: groupParticipations.id },
      groupParticipations
    );
  };
};

export const updateActiveLayerAllGroupParticipations = (
  groupParticipationsId,
  participants,
  add
) => {
  return async (dispatch, getState, { apiClient }) => {
    let groupParticipations = find(getState().analysis.single.groupParticipations, {
      id: groupParticipationsId
    });
    if (groupParticipations) {
      groupParticipations = cloneDeep(groupParticipations);

      const participantsIds = participants.map(participant => {
        return participant.id;
      });

      if (add) {
        groupParticipations.participations = participantsIds;
      } else {
        groupParticipations.participations = [];
      }

      dispatch(updateGroupParticipations(groupParticipations));
    }
  };
};

export const updateActiveLayerGroupParticipations = (groupParticipationsId, add) => {
  return async (dispatch, getState, { apiClient }) => {
    if (getState().analysis.single.activeLayerId !== null) {
      const activeLayer = cloneDeep(
        find(getState().analysis.single.layers, { id: getState().analysis.single.activeLayerId })
      );

      // Add Association
      if (add) {
        activeLayer.layer_group_participations_associations.push({
          group_participations_id: groupParticipationsId,
          layer_id: activeLayer.id
        });
      } else {
        const associationIndex = findIndex(activeLayer.layer_group_participations_associations, {
          group_participations_id: groupParticipationsId
        });
        activeLayer.layer_group_participations_associations.splice(associationIndex, 1);
      }

      dispatch(updateLayer(activeLayer));
    }
  };
};

export const updateGroupParticipationParticipations = (
  groupParticipationsId,
  participationId,
  add
) => {
  return async (dispatch, getState, { apiClient }) => {
    let groupParticipations = find(getState().analysis.single.groupParticipations, {
      id: groupParticipationsId
    });
    if (groupParticipations) {
      groupParticipations = cloneDeep(groupParticipations);
      if (add) {
        groupParticipations.participations.push(participationId);
      } else {
        const participationIndex = groupParticipations.participations.indexOf(participationId);
        if (participationIndex >= 0) {
          groupParticipations.participations.splice(participationIndex, 1);
        }
      }

      dispatch(updateGroupParticipations(groupParticipations));
    }
  };
};

export const updateGroupParticipationName = (groupParticipationsId, name) => {
  return async (dispatch, getState, { apiClient }) => {
    let groupParticipations = find(getState().analysis.single.groupParticipations, {
      id: groupParticipationsId
    });
    if (groupParticipations) {
      groupParticipations = cloneDeep(groupParticipations);
      groupParticipations.name = name;

      dispatch(updateGroupParticipations(groupParticipations));
    }
  };
};

export const updateProjectAnalysisGroupParticipationsInStore = payload => {
  return (dispatch, getState) => {
    let newGroupParticipations;

    if (payload.operation === 'remove') {
      newGroupParticipations = filter(
        getState().analysis.single.groupParticipations,
        groupParticipation => {
          return groupParticipation.id !== payload.data.id;
        }
      );
    } else {
      let isNew = true;
      newGroupParticipations = getState().analysis.single.groupParticipations.map(
        groupParticipation => {
          if (payload.data.id === groupParticipation.id) {
            isNew = false;
            return payload.data;
          }
          return groupParticipation;
        }
      );
      if (isNew) {
        newGroupParticipations.push(payload.data);
      }
    }

    dispatch(setProjectAnalysisGroupParticipations(newGroupParticipations));
  };
};

export const createGroupParticipations = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const group = await apiClient.call(
      GROUP_PARTICIPATIONS_TAG,
      'createGroupParticipations',
      null,
      {
        project_id: projectId,
        name: !isNil(last(getState().analysis.single.groupParticipations))
          ? `Group ${last(getState().analysis.single.groupParticipations).id + 1}`
          : `Group 1`
      }
    );

    dispatch(updateActiveLayerGroupParticipations(group.id, true));
  };
};

export const deleteGroupParticipations = groupParticipationsId => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(GROUP_PARTICIPATIONS_TAG, 'deleteGroupParticipations', {
      id: groupParticipationsId
    });
  };
};

export const fetchProjectAnalysisGroupParticipations = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, 'getProjectGroupParticipations', {
      projectId,
      $limit: 100
    });

    dispatch(setProjectAnalysisGroupParticipations(results.data));
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/participationsActions.js